import { createWithEqualityFn } from "zustand/traditional";
import { createJSONStorage, persist } from "zustand/middleware";
import { storage } from "../utils/custom-storage";
import { shallow } from "zustand/shallow";
interface AuthState {
  user: AuthUser | null;
  auth: AuthToken | null;
  saveAuth: (auth: AuthToken | null) => void;
  setUser: (user: AuthUser | null) => void;
  logout: () => void;
}

const useAuth = createWithEqualityFn<AuthState>()(
  persist(
    (set) => ({
      user: null,
      auth: null,
      saveAuth: (auth) => {
        set((state) => ({ ...state, auth }));
      },
      setUser: (user) => {
        set((state) => ({ ...state, user }));
      },
      logout: () => {
        set((state) => ({ ...state, user: null, auth: null }));
      },
    }),
    {
      name: import.meta.env.VITE_APP_AUTH_STORE_KEY ?? "web-auth",
      storage: createJSONStorage(() => storage),
    }
  ),
  shallow
);

export default useAuth;
